import axios from "axios";
import { useCountryStore } from "../stores/useCountry";
import { getRegionalizationCode } from "../utils/regionalizacao";

const BASE_URL = process.env.REACT_APP_API_URL_BASE;

export const api = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use((config) => {
  const country = useCountryStore.getState().country ?? "BR";
  const acceptLanguage = getRegionalizationCode(country);

  config.headers.set?.("X-Regionalization-Code", acceptLanguage);
  config.headers.set?.("Content-Type", "application/json");
  config.headers.set?.(
    "Authorization",
    `Basic ${process.env.REACT_APP_AUTHORIZATION_BASIC}`,
  );

  return config;
});
